import { FC } from 'react'
import type { ERC20Symbols } from '@g4g/wallet-modal/types'
import CryptoPriceTag from '../../../../shopping-cart/cart-page/CryptoPriceTag'
import { classNames } from '@g4g/utils/src/react/class-names'

const CheckoutPaymentTokenSquare: FC<{
  tokenSymbol: ERC20Symbols
  checked: boolean
  disabled: boolean
  loading: boolean
  humanBalance?: string
  humanPrice?: string
}> = ({ humanBalance, tokenSymbol, checked, humanPrice, disabled, loading }) => (
  <>
    <div
      className={classNames(
        checked && !disabled && 'ring-2 ring-green-300',
        'px-2 py-2 sm:px-4 bg-gray-600 rounded-lg hover:bg-gray-600/80'
      )}
    >
      <CryptoPriceTag
        size="large"
        symbol={tokenSymbol}
        price={humanPrice}
        layout="compact"
        data-cy-spec={`shop-cart-crypto-price-tag-${tokenSymbol.toLowerCase()}`}
      />
    </div>
    {!loading && disabled && humanBalance && (
      <div className="flex items-center justify-center mt-1 sm:mt-3 sm:flex-col">
        <p className="hidden font-bold text-yellow-300 sm:flex">Insufficient funds</p>
        <div className="text-sm text-center text-yellow-300/80">
          <span className="sr-only sm:not-sr-only">Current {tokenSymbol} </span>
          <span>balance: {humanBalance}</span>
        </div>
      </div>
    )}
  </>
)

export default CheckoutPaymentTokenSquare
